import React, { Component } from 'react'


export default class PaginationControls extends Component {
    state = {
        inputPage: '',
        showJumpInput: true
    }

    handleInputChange = (e) => {
        const value = e.target.value;
        // Solo permitir números
        if (/^\d*$/.test(value)) {
            this.setState({ inputPage: value });
        }
    }

    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.goToPage();
        }
    }

    goToPage = () => {
        const { inputPage } = this.state;
        const { totalPages, onPageChange } = this.props;
        const pageNum = parseInt(inputPage);

        if (pageNum >= 1 && pageNum <= totalPages) {
            onPageChange(pageNum);
            this.setState({ inputPage: '', showJumpInput: true });
        } else {
            alert(`Por favor ingrese un número entre 1 y ${totalPages}`);
        }
    }

    generateQuickJumpPages = () => {
        const { totalPages, currentPage } = this.props;
        const jumps = [];

        // Páginas de salto rápido: cada 10, 50, 100 páginas
        const intervals = [
            Math.ceil(totalPages * (1/8)),
            Math.ceil(totalPages * (2/8)),
            Math.ceil(totalPages * (6/8)),
            Math.ceil(totalPages * (7/8)),
        ];
        /* const intervals = [
            9+currentPage,
            24+currentPage,
            49+currentPage,
            99+currentPage,
        ]; */

        intervals.forEach(interval => {
            for (let i = interval; i <= totalPages; i += interval) {
                if (!jumps.includes(i) && jumps.length < 6) {
                    jumps.push(i);
                }
            }
        });

        return jumps;
    }

    render() {
        const { currentPage, totalPages, onPageChange } = this.props;
        const { inputPage, showJumpInput } = this.state;

        if (!totalPages || totalPages <= 10) {
            // Si hay pocas páginas, no mostrar controles avanzados
            return null;
        }

        const quickJumps = this.generateQuickJumpPages();

        return (
            <div className="enhanced-pagination-controls" style={{
                background: '#f8f9fa',
                padding: '15px',
                borderRadius: '5px',
                margin: '10px 0',
                border: '1px solid #e9ecef',
                fontSize: 20,
            }}>
                <div className="row">
                    <div className="col-md-4 d-flex align-items-center justify-content-center">
                        <small className="text-muted">
                            Página {currentPage} de {totalPages}
                        </small>
                    </div>

                    <div className="col-md-4 d-flex align-items-center justify-content-center">
                        {!showJumpInput ? (
                            <button
                                className="btn btn-secondary"
                                onClick={() => this.setState({ showJumpInput: true })}
                                title="Ir directamente a una página específica"
                            >
                                Saltar a página
                            </button>
                        ) : (
                            <div className="input-group input-group-sm" style={{maxWidth: '180px'}}>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder={`1-${totalPages} (Enter)`}
                                    value={inputPage}
                                    onChange={this.handleInputChange}
                                    onKeyPress={this.handleKeyPress}
                                    autoFocus
                                    title="Escribe el número de página y presiona Enter"
                                />
                                {/*
                                <div className="input-group-append">
                                    <button
                                        className="btn btn-secondary btn-sm"
                                        onClick={() => this.setState({ showJumpInput: false, inputPage: '' })}
                                        title="Cancelar"
                                    >
                                        ✕
                                    </button>
                                </div>
                                */}
                            </div>
                        )}
                    </div>

                    <div className="col-md-4 d-flex align-items-center justify-content-center">
                        {quickJumps.length > 0 && (
                            <div className="btn-group">
                                <button
                                    type="button"
                                    className="btn btn-secondary dropdown-toggle"
                                    data-toggle="dropdown"
                                    title="Saltos rápidos a páginas importantes"
                                >
                                    Saltos rápidos
                                </button>
                                <div className="dropdown-menu">
                                    <h6 className="dropdown-header">Ir rápidamente a:</h6>
                                    {quickJumps.map(pageNum => (
                                        <button
                                            key={pageNum}
                                            className="dropdown-item"
                                            onClick={() => onPageChange(pageNum)}
                                        >
                                            Página {pageNum}
                                        </button>
                                    ))}
                                    <div className="dropdown-divider"></div>
                                    <button
                                        className="dropdown-item"
                                        onClick={() => onPageChange(Math.ceil(totalPages / 2))}
                                    >
                                        Página central ({Math.ceil(totalPages / 2)})
                                    </button>
                                    <button
                                        className="dropdown-item"
                                        onClick={() => onPageChange(totalPages)}
                                    >
                                        Última página ({totalPages})
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}